import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

const SearchOrderByFilter = (props) => {
	const value = props.value;
	const onChange = props.onChange;
	const mobile = props.mobile;
	return (
		<FormControl variant="outlined" className={mobile ? "w-100 mx-7 px-10 my-14" : "w-100 pr-0"}>
			<InputLabel className={mobile ? "pl-10 ml-4" : ""} id="orderBy">
				Order By
			</InputLabel>
			<Select label="orderBy" id="orderBy" value={value} onChange={(event) => onChange(event.target.value)}>
				<MenuItem value="MATCH">{"Match"}</MenuItem>
				<MenuItem value="RATE">{"Rate"}</MenuItem>
				<MenuItem value="RPM">{"RPM"}</MenuItem>
				<MenuItem value="PROFIT">{"Profit"}</MenuItem>
				<MenuItem value="AGE">{"Age"}</MenuItem>
				<MenuItem value="MPI">{"MPI"}</MenuItem>
				<MenuItem value="DHO">{"DH-O"}</MenuItem>
			</Select>
		</FormControl>
	);
};

export default SearchOrderByFilter;
